import { RenderAnalysisSummaryItemProps } from "@models/platform-analysis/entities/steps/summary";
import { FeatureAnalysisCollapseStateFilterLevel } from "@models/platform-analysis/enums/feature/featureAnalysisCollapseLevelFilter";
import { FeesDisplayMode } from "@models/platform-analysis/enums/fee/displayMode";
import { FeeCalculatorPortfolioLevel } from "@models/platform-analysis/enums/fee/portfolioLevel";
import { disqualifiedFeeAnalysisSmaTableRowsSelectors } from "@redux/slices/platform-analysis";
import { RootState } from "@redux/store";
import { memo } from "react";
import { FeeSMAPortfolioSection } from "../../../fee/analysis/components/fee-sma-portfolio-section";

export const SummaryAppendixSmaPortfolioFees = memo(
  ({ portfolioLevel }: RenderAnalysisSummaryItemProps) => {
    if (portfolioLevel !== FeeCalculatorPortfolioLevel.Family) return <></>;

    return (
      <FeeSMAPortfolioSection
        isAppendix={true}
        getHiddenIdsIndexMap={(state: RootState) =>
          state.platformAnalysis?.internal?.feeAnalysis
            ?.disqualifiedHiddenIdsIndexMap
        }
        virtualizeProps={{
          matchParentContainerWidth: true,
          title: "",
          tableTitle: "",
          removeToolbar: true,
          allowFilters: false,
          ignoreScrollBackToTopEvent: true,
          showSectionTooltip: true,
          showSubSectionTooltip: true,
          getSelectedProductsFunc: () => undefined,
          getCurrentDataFunc:
            disqualifiedFeeAnalysisSmaTableRowsSelectors.selectAll,
          getCurrentCollapseLevelFunc: () =>
            FeatureAnalysisCollapseStateFilterLevel.FeatureLevel,
          getCollapseLevelChangedManuallyFunc: () => false,
          shouldHideCollapseArrow: (state: RootState) =>
            state.platformAnalysis?.internal?.feeAnalysis?.displayMode ===
            FeesDisplayMode.Summary,
          getHiddenColumnIndexesMapFunc: (state: RootState) =>
            state.platformAnalysis?.internal?.feeAnalysis
              ?.disqualifiedHiddenIdsIndexMap || [],
          getSelectedSubProductsFunc: (state: RootState) =>
            state.platformAnalysis?.platformAnalysis?.summary
              ?.disqualifiedSmaPortfolioFee?.selectedSubProducts,
        }}
      />
    );
  },
);
